export type MovieCategory = "movie" | "tv" | "variety";

export interface Movie {
  id: number;
  title: string;
  category: MovieCategory;
  year: number;
  genres: string[];
  region: string;
  rating: number;
  views: number;
  duration: string;
  episodes: number;
  director: string;
  actors: string[];
  poster: string;
  backdrop: string;
  description: string;
  featured?: boolean;
  updatedAt: string;
}

export const categoryLabels: Record<MovieCategory, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const categoryTagline: Record<MovieCategory, string> = {
  movie: "精选院线大片与经典佳作，高清画质，一网打尽。",
  tv: "热播剧集持续更新，追剧不停歇，剧情跌宕起伏。",
  variety: "爆笑真人秀与音乐舞台，轻松治愈每一刻。",
};

export const movies: Movie[] = [
  {
    id: 1,
    title: "星际迷航：暗夜边界",
    category: "movie",
    year: 2025,
    genres: ["科幻", "冒险"],
    region: "美国",
    rating: 9.1,
    views: 8620,
    duration: "148分钟",
    episodes: 1,
    director: "克里斯托弗·诺兰",
    actors: ["马修·麦康纳", "安妮·海瑟薇", "杰西卡·查斯坦"],
    poster:
      "https://readdy.ai/api/search-image?query=A%20cinematic%20science%20fiction%20movie%20poster%20artwork%20showing%20a%20lone%20astronaut%20standing%20before%20a%20vast%20glowing%20nebula%20with%20deep%20blue%20and%20orange%20color%20grading%20and%20a%20dark%20dramatic%20space%20background%20rendered%20in%20high%20detail%20professional%20digital%20painting%20style&width=600&height=900&seq=poster-scifi-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%20with%20a%20spaceship%20flying%20toward%20a%20luminous%20purple%20and%20orange%20nebula%20surrounded%20by%20countless%20stars%20in%20deep%20dark%20cosmos%20moody%20high%20contrast%20lighting%20ultra%20detailed%20digital%20art%20wide%20composition&width=1600&height=900&seq=backdrop-scifi-01&orientation=landscape",
    description:
      "当地球资源濒临枯竭，一支由顶尖宇航员组成的探险队穿越虫洞，前往遥远星系寻找人类新的家园。面对时间与空间的极限考验，他们必须在亲情与使命之间做出抉择。",
    featured: true,
    updatedAt: "2025-09-28",
  },
  {
    id: 2,
    title: "长安幻夜",
    category: "movie",
    year: 2025,
    genres: ["奇幻", "古装"],
    region: "中国大陆",
    rating: 8.6,
    views: 7310,
    duration: "132分钟",
    episodes: 1,
    director: "陈凯歌",
    actors: ["易烊千玺", "周迅", "张若昀"],
    poster:
      "https://readdy.ai/api/search-image?query=A%20mystical%20ancient%20Chinese%20fantasy%20movie%20poster%20with%20a%20graceful%20figure%20in%20flowing%20silk%20robes%20standing%20under%20lantern%20light%20deep%20blue%20night%20and%20warm%20orange%20glow%20dark%20atmospheric%20background%20highly%20detailed%20cinematic%20painting&width=600&height=900&seq=poster-fantasy-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=A%20magical%20ancient%20Chinese%20capital%20city%20at%20night%20with%20glowing%20lanterns%20floating%20in%20the%20sky%20traditional%20palaces%20and%20a%20lone%20silhouette%20figure%20deep%20blue%20tones%20with%20warm%20orange%20highlights%20epic%20cinematic%20wide%20shot%20detailed&width=1600&height=900&seq=backdrop-fantasy-02&orientation=landscape",
    description:
      "盛唐长安的深夜，一位神秘的幻术师卷入宫廷秘案。随着谜团层层揭开，繁华都市之下隐藏的古老力量逐渐苏醒，一段跨越千年的宿命就此展开。",
    featured: true,
    updatedAt: "2025-09-20",
  },
  {
    id: 3,
    title: "都市迷城",
    category: "movie",
    year: 2024,
    genres: ["犯罪", "悬疑"],
    region: "中国香港",
    rating: 8.3,
    views: 5240,
    duration: "118分钟",
    episodes: 1,
    director: "杜琪峰",
    actors: ["古天乐", "刘德华", "倪妮"],
    poster:
      "https://readdy.ai/api/search-image?query=A%20gritty%20crime%20thriller%20movie%20poster%20of%20a%20detective%20in%20a%20trench%20coat%20under%20neon%20city%20lights%20at%20night%20deep%20blue%20and%20amber%20color%20grading%20rainy%20dark%20street%20atmosphere%20high%20detail%20cinematic%20photography&width=600&height=900&seq=poster-crime-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=A%20rain%20soaked%20metropolitan%20city%20street%20at%20night%20with%20reflective%20neon%20signs%20and%20shadows%20of%20a%20walking%20figure%20deep%20blue%20tones%20with%20orange%20street%20lamp%20glow%20moody%20cinematic%20wide%20shot%20ultra%20detailed&width=1600&height=900&seq=backdrop-crime-03&orientation=landscape",
    description:
      "一桩离奇的连环案件打破了城市的平静。经验老道的警探与年轻记者联手追查真相，却发现案件背后牵扯出一张庞大的利益网络，每个人都可能是棋子。",
    updatedAt: "2025-08-30",
  },
  {
    id: 4,
    title: "深海救援",
    category: "movie",
    year: 2025,
    genres: ["动作", "冒险"],
    region: "中国大陆",
    rating: 8.0,
    views: 6110,
    duration: "126分钟",
    episodes: 1,
    director: "林超贤",
    actors: ["吴京", "彭于晏", "姚晨"],
    poster:
      "https://readdy.ai/api/search-image?query=A%20dramatic%20ocean%20rescue%20action%20movie%20poster%20with%20a%20diver%20facing%20towering%20waves%20deep%20blue%20underwater%20tones%20with%20orange%20emergency%20light%20high%20detail%20cinematic%20digital%20artwork%20dark%20moody%20atmosphere&width=600&height=900&seq=poster-action-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=A%20huge%20stormy%20ocean%20with%20a%20rescue%20helicopter%20hovering%20above%20crashing%20waves%20and%20a%20lone%20vessel%20in%20deep%20blue%20water%20orange%20emergency%20flares%20lighting%20cinematic%20wide%20shot%20ultra%20detailed%20dramatic&width=1600&height=900&seq=backdrop-action-04&orientation=landscape",
    description:
      "一场突如其来的海底灾难让钻井平台陷入绝境。救援队长带领队员与时间赛跑，在冰冷深海与汹涌暗流中展开一场惊心动魄的生死救援。",
    updatedAt: "2025-09-12",
  },
  {
    id: 5,
    title: "时光信笺",
    category: "movie",
    year: 2024,
    genres: ["爱情", "剧情"],
    region: "韩国",
    rating: 8.4,
    views: 4280,
    duration: "112分钟",
    episodes: 1,
    director: "朴赞郁",
    actors: ["玄彬", "孙艺珍", "金高银"],
    poster:
      "https://readdy.ai/api/search-image?query=A%20tender%20romance%20movie%20poster%20showing%20two%20figures%20standing%20apart%20in%20soft%20rain%20with%20a%20golden%20sunset%20deep%20blue%20evening%20shadows%20and%20warm%20orange%20light%20high%20detail%20cinematic%20painting%20emotional%20atmosphere&width=600&height=900&seq=poster-romance-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=A%20dreamy%20rainy%20old%20town%20street%20at%20dusk%20with%20warm%20orange%20streetlights%20and%20a%20couple%20holding%20an%20umbrella%20deep%20blue%20twilight%20tones%20cinematic%20wide%20shot%20soft%20melancholic%20mood%20detailed&width=1600&height=900&seq=backdrop-romance-05&orientation=landscape",
    description:
      "一封被尘封多年的旧信，让两个本已错过的人重新相遇。在时间与记忆的交错中，他们能否找回那段被遗忘的温柔岁月，写下属于自己的结局。",
    updatedAt: "2025-07-18",
  },
  {
    id: 6,
    title: "荒野逐光",
    category: "movie",
    year: 2025,
    genres: ["冒险", "剧情"],
    region: "英国",
    rating: 8.2,
    views: 3990,
    duration: "121分钟",
    episodes: 1,
    director: "丹尼·博伊尔",
    actors: ["汤姆·哈迪", "艾玛·沃森", "基里安·墨菲"],
    poster:
      "https://readdy.ai/api/search-image?query=A%20lone%20wanderer%20walking%20across%20a%20vast%20mountain%20wilderness%20at%20golden%20sunset%20movie%20poster%20composition%20deep%20blue%20long%20shadows%20with%20warm%20orange%20sunlight%20high%20detail%20cinematic%20landscape%20photography&width=600&height=900&seq=poster-adventure-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=A%20breathtaking%20mountain%20valley%20at%20golden%20hour%20with%20one%20tiny%20figure%20standing%20on%20a%20cliff%20edge%20deep%20blue%20distant%20peaks%20and%20warm%20orange%20sunlight%20cinematic%20ultra%20wide%20shot%20highly%20detailed%20epic&width=1600&height=900&seq=backdrop-adventure-06&orientation=landscape",
    description:
      "为了完成父亲的遗愿，一位年轻的探险家独自踏入无人荒野。在极端自然与内心恐惧的双重考验下，他逐渐明白，真正的征途是找到与自己和解的勇气。",
    updatedAt: "2025-08-05",
  },
  {
    id: 7,
    title: "无声证言",
    category: "movie",
    year: 2024,
    genres: ["悬疑", "剧情"],
    region: "中国大陆",
    rating: 8.7,
    views: 5480,
    duration: "124分钟",
    episodes: 1,
    director: "曹保平",
    actors: ["黄渤", "周冬雨", "王砚辉"],
    poster:
      "https://readdy.ai/api/search-image?query=A%20tense%20mystery%20movie%20poster%20of%20a%20lone%20witness%20seen%20through%20blurred%20glass%20in%20a%20dark%20interrogation%20room%20deep%20blue%20shadows%20with%20a%20single%20orange%20lamp%20high%20detail%20cinematic%20photography%20moody%20atmosphere&width=600&height=900&seq=poster-suspense-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=An%20empty%20dim%20interrogation%20room%20at%20night%20with%20a%20cold%20metal%20table%20and%20a%20single%20harsh%20overhead%20light%20deep%20blue%20shadows%20with%20warm%20orange%20lamp%20glow%20cinematic%20wide%20shot%20suspenseful%20detailed&width=1600&height=900&seq=backdrop-suspense-07&orientation=landscape",
    description:
      "一名目击者的沉默，让一桩旧案重新被翻出水面。当真相与谎言层层交叠，法律与人性的边界变得模糊，所有人都必须为沉默付出代价。",
    updatedAt: "2025-06-22",
  },
  {
    id: 8,
    title: "山河故人录",
    category: "movie",
    year: 2023,
    genres: ["剧情", "古装"],
    region: "中国大陆",
    rating: 8.9,
    views: 4760,
    duration: "155分钟",
    episodes: 1,
    director: "贾樟柯",
    actors: ["张译", "段奕宏", "袁泉"],
    poster:
      "https://readdy.ai/api/search-image?query=A%20poetic%20historical%20Chinese%20drama%20movie%20poster%20with%20a%20lone%20scholar%20gazing%20at%20distant%20mountains%20deep%20blue%20misty%20horizon%20and%20warm%20orange%20sunset%20light%20high%20detail%20cinematic%20imagery%20elegant%20melancholic&width=600&height=900&seq=poster-drama-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=A%20vast%20misty%20ancient%20Chinese%20landscape%20with%20layered%20mountains%20a%20river%20and%20a%20tiny%20traveler%20deep%20blue%20haze%20with%20warm%20orange%20dusk%20light%20cinematic%20ultra%20wide%20shot%20poetic%20detailed&width=1600&height=900&seq=backdrop-drama-08&orientation=landscape",
    description:
      "跨越三代人的家族史诗，讲述了在山河变迁中普通人的聚散离合。时代洪流之下，每个人都在寻找属于自己的位置与归宿，写下一部沉默而深情的地方志。",
    updatedAt: "2025-05-14",
  },
  {
    id: 9,
    title: "长安十二辰",
    category: "tv",
    year: 2025,
    genres: ["古装", "悬疑"],
    region: "中国大陆",
    rating: 9.0,
    views: 9340,
    duration: "45分钟",
    episodes: 36,
    director: "曹盾",
    actors: ["雷佳音", "易烊千玺", "周一围"],
    poster:
      "https://readdy.ai/api/search-image?query=A%20grand%20ancient%20Chinese%20costume%20drama%20poster%20with%20an%20official%20in%20elaborate%20armor%20standing%20in%20a%20lantern%20lit%20palace%20deep%20blue%20night%20and%20warm%20orange%20firelight%20high%20detail%20cinematic%20historical%20artwork&width=600&height=900&seq=poster-hist-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=A%20sprawling%20ancient%20Chinese%20imperial%20city%20at%20night%20with%20countless%20glowing%20lanterns%20and%20rooftops%20stretching%20to%20the%20horizon%20deep%20blue%20tones%20with%20warm%20orange%20light%20cinematic%20epic%20wide%20shot%20ultra%20detailed&width=1600&height=900&seq=backdrop-hist-09&orientation=landscape",
    description:
      "上元节前夕，长安城暗流涌动。一位身陷囹圄的死囚与少年天才联手，在十二个时辰内阻止一场足以颠覆王朝的惊天阴谋，时间一分一秒地流逝。",
    featured: true,
    updatedAt: "2025-10-02",
  },
  {
    id: 10,
    title: "迷雾追凶",
    category: "tv",
    year: 2025,
    genres: ["悬疑", "都市"],
    region: "中国大陆",
    rating: 8.6,
    views: 7120,
    duration: "42分钟",
    episodes: 28,
    director: "五百",
    actors: ["廖凡", "白宇", "谭卓"],
    poster:
      "https://readdy.ai/api/search-image?query=A%20dark%20crime%20series%20poster%20showing%20a%20detective%20silhouette%20in%20thick%20fog%20under%20a%20flickering%20streetlight%20deep%20blue%20mist%20with%20a%20hint%20of%20orange%20glow%20high%20detail%20cinematic%20suspense%20atmosphere%20moody&width=600&height=900&seq=poster-crimetv-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=A%20foggy%20city%20overpass%20at%20dawn%20with%20dim%20streetlights%20and%20a%20lone%20car%20on%20the%20road%20deep%20blue%20haze%20with%20subtle%20warm%20orange%20glow%20cinematic%20wide%20shot%20mysterious%20ultra%20detailed&width=1600&height=900&seq=backdrop-crimetv-10&orientation=landscape",
    description:
      "一座被迷雾笼罩的城市接连发生离奇案件。执着的老刑警与冷静的心理分析师组成搭档，在层层迷雾中抽丝剥茧，逼近那个藏在暗处的真相。",
    updatedAt: "2025-09-25",
  },
  {
    id: 11,
    title: "医者仁心",
    category: "tv",
    year: 2024,
    genres: ["都市", "剧情"],
    region: "中国大陆",
    rating: 8.5,
    views: 6320,
    duration: "45分钟",
    episodes: 40,
    director: "张黎",
    actors: ["靳东", "海清", "张嘉译"],
    poster:
      "https://readdy.ai/api/search-image?query=A%20warm%20medical%20drama%20poster%20of%20a%20dedicated%20doctor%20in%20a%20white%20coat%20standing%20in%20a%20dim%20hospital%20corridor%20deep%20blue%20shadows%20with%20soft%20orange%20light%20high%20detail%20cinematic%20photography%20hopeful%20mood&width=600&height=900&seq=poster-medical-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=An%20empty%20modern%20hospital%20corridor%20at%20night%20with%20soft%20glowing%20lights%20and%20clean%20lines%20deep%20blue%20tones%20with%20warm%20orange%20accents%20cinematic%20wide%20shot%20calm%20detailed%20atmosphere&width=1600&height=900&seq=backdrop-medical-11&orientation=landscape",
    description:
      "一群奋战在急诊一线的医护人员，在生死边缘与时间赛跑。他们用专业与温情守护每一个生命，也在一次次抉择中重新理解责任、信念与人性的分量。",
    updatedAt: "2025-08-15",
  },
  {
    id: 12,
    title: "星河彼岸",
    category: "tv",
    year: 2025,
    genres: ["科幻", "剧情"],
    region: "美国",
    rating: 8.8,
    views: 6890,
    duration: "50分钟",
    episodes: 24,
    director: "乔纳森·诺兰",
    actors: ["艾米莉亚·克拉克", "佩德罗·帕斯卡", "奥斯卡·伊萨克"],
    poster:
      "https://readdy.ai/api/search-image?query=A%20futuristic%20sci%20fi%20series%20poster%20of%20an%20explorer%20in%20a%20sleek%20suit%20gazing%20at%20a%20distant%20glowing%20planet%20deep%20blue%20space%20tones%20with%20warm%20orange%20horizon%20light%20high%20detail%20cinematic%20digital%20painting%20epic&width=600&height=900&seq=poster-scifitv-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=A%20vast%20alien%20landscape%20with%20towering%20rock%20formations%20under%20a%20giant%20ringed%20planet%20in%20the%20sky%20deep%20blue%20tones%20with%20warm%20orange%20sunlight%20cinematic%20ultra%20wide%20shot%20highly%20detailed%20sci%20fi&width=1600&height=900&seq=backdrop-scifitv-12&orientation=landscape",
    description:
      "人类的第一艘星际殖民船抵达神秘星球，却发现这里早已存在未知文明。面对前所未有的挑战，船员们必须在生存与信念之间寻找平衡，探索星河彼岸的真相。",
    updatedAt: "2025-09-30",
  },
  {
    id: 13,
    title: "烟火人间",
    category: "tv",
    year: 2024,
    genres: ["都市", "生活"],
    region: "中国大陆",
    rating: 8.4,
    views: 4980,
    duration: "40分钟",
    episodes: 32,
    director: "孔笙",
    actors: ["雷佳音", "宋佳", "咏梅"],
    poster:
      "https://readdy.ai/api/search-image?query=A%20heartwarming%20family%20drama%20poster%20of%20a%20family%20gathered%20around%20a%20dinner%20table%20in%20a%20small%20alley%20at%20dusk%20deep%20blue%20evening%20tones%20with%20warm%20orange%20lamp%20light%20high%20detail%20cinematic%20painting&width=600&height=900&seq=poster-life-13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=A%20quiet%20old%20residential%20alley%20at%20dusk%20with%20warm%20glowing%20windows%20and%20hanging%20lanterns%20deep%20blue%20twilight%20sky%20with%20orange%20light%20cinematic%20wide%20shot%20cozy%20detailed%20atmosphere&width=1600&height=900&seq=backdrop-life-13&orientation=landscape",
    description:
      "一条老街，三代人，无数个平凡却温暖的日子。家长里短的琐碎背后，是中国人最朴素的坚守与温情，讲述属于每个普通人的烟火人间。",
    updatedAt: "2025-07-08",
  },
  {
    id: 14,
    title: "欢乐大本营",
    category: "variety",
    year: 2025,
    genres: ["娱乐", "真人秀"],
    region: "中国大陆",
    rating: 8.1,
    views: 7850,
    duration: "90分钟",
    episodes: 48,
    director: "综艺制作中心",
    actors: ["何炅", "谢娜", "李维嘉", "吴昕"],
    poster:
      "https://readdy.ai/api/search-image?query=A%20vibrant%20Chinese%20variety%20show%20poster%20with%20colorful%20stage%20lights%20and%20a%20joyful%20host%20silhouette%20deep%20blue%20backdrop%20with%20bright%20orange%20spotlights%20high%20detail%20energetic%20cinematic%20design%20fun%20atmosphere&width=600&height=900&seq=poster-variety-14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=A%20dazzling%20TV%20studio%20stage%20with%20colorful%20spotlights%20and%20glowing%20screens%20deep%20blue%20backdrop%20with%20bright%20orange%20beams%20cinematic%20wide%20shot%20energetic%20highly%20detailed%20variety%20show&width=1600&height=900&seq=backdrop-variety-14&orientation=landscape",
    description:
      "汇聚人气明星与素人嘉宾的国民级综艺，通过趣味游戏、爆笑互动与即兴表演，为观众带来最纯粹的快乐，每周欢乐不停歇。",
    featured: true,
    updatedAt: "2025-10-05",
  },
  {
    id: 15,
    title: "极限挑战营",
    category: "variety",
    year: 2025,
    genres: ["真人秀", "冒险"],
    region: "中国大陆",
    rating: 8.3,
    views: 6630,
    duration: "95分钟",
    episodes: 36,
    director: "户外综艺工作室",
    actors: ["黄渤", "孙红雷", "王迅", "张艺兴"],
    poster:
      "https://readdy.ai/api/search-image?query=An%20adventurous%20reality%20show%20poster%20of%20a%20group%20of%20contestants%20standing%20on%20a%20cliff%20at%20sunset%20deep%20blue%20sky%20tones%20with%20warm%20orange%20light%20high%20detail%20cinematic%20outdoor%20photography%20energetic%20feel&width=600&height=900&seq=poster-reality-15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=A%20rugged%20outdoor%20course%20with%20obstacles%20on%20cliffs%20and%20roaring%20bonfires%20under%20a%20deep%20blue%20evening%20sky%20with%20warm%20orange%20glow%20cinematic%20wide%20shot%20dramatic%20detailed%20adventure&width=1600&height=900&seq=backdrop-reality-15&orientation=landscape",
    description:
      "六位固定嘉宾组成的挑战团，深入荒野与城市完成任务。在极限环境中考验默契与智慧，笑料百出的同时，也展现真实动人的兄弟情谊。",
    updatedAt: "2025-09-18",
  },
  {
    id: 16,
    title: "声音的舞台",
    category: "variety",
    year: 2024,
    genres: ["音乐", "娱乐"],
    region: "中国大陆",
    rating: 8.6,
    views: 5720,
    duration: "100分钟",
    episodes: 30,
    director: "音乐综艺中心",
    actors: ["李健", "林俊杰", "周深", "张韶涵"],
    poster:
      "https://readdy.ai/api/search-image?query=A%20soulful%20music%20show%20poster%20of%20a%20singer%20silhouette%20holding%20a%20microphone%20under%20a%20single%20spotlight%20deep%20blue%20stage%20darkness%20with%20warm%20orange%20glow%20high%20detail%20cinematic%20artwork%20emotional%20atmosphere&width=600&height=900&seq=poster-music-16&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=An%20elegant%20concert%20stage%20with%20a%20grand%20piano%20and%20warm%20spotlights%20in%20deep%20blue%20darkness%20with%20orange%20glow%20effects%20cinematic%20wide%20shot%20atmospheric%20highly%20detailed%20music%20venue&width=1600&height=900&seq=backdrop-music-16&orientation=landscape",
    description:
      "顶级歌手同台竞技的音乐舞台，通过不同主题改编经典与原创作品。用心诠释每一首歌，让音乐跨越语言与风格，直抵听众内心最柔软的地方。",
    updatedAt: "2025-06-30",
  },
];

export const heroSlides = [1, 9, 14, 2, 12]
  .map((id) => movies.find((m) => m.id === id))
  .filter((m): m is Movie => Boolean(m));

export const genreOptions: Record<MovieCategory, string[]> = {
  movie: ["全部", "科幻", "奇幻", "犯罪", "悬疑", "动作", "爱情", "冒险", "剧情", "古装"],
  tv: ["全部", "古装", "悬疑", "都市", "科幻", "剧情", "生活"],
  variety: ["全部", "娱乐", "真人秀", "冒险", "音乐"],
};

export const regionOptions: Record<MovieCategory, string[]> = {
  movie: ["全部", "中国大陆", "美国", "中国香港", "英国", "韩国"],
  tv: ["全部", "中国大陆", "美国"],
  variety: ["全部", "中国大陆"],
};

export const yearOptions = ["全部", "2025", "2024", "2023", "2022"];

export const hotKeywords = [
  "星际迷航",
  "长安十二辰",
  "欢乐大本营",
  "深海救援",
  "迷雾追凶",
  "星河彼岸",
];